import React, {memo} from 'react';
import {FlatList, ScrollView, View} from 'react-native';
import {noop} from 'lodash';
import PropTypes from 'prop-types';

import KeyboardFocusable from '/component/base/ExtKeyboard/KeyboardFocusable';
import Text from '/component/base/Text';
import {getRenderItem} from '/component/partial/report/PeopleReportDataRenderer/PeopleReportDataRenderer';
import {getKeyExtractor} from '/component/partial/report/PeopleReportDataRenderer/PeopleReportListItem.util';
import ReportDefaultLoading from '/component/partial/report/ReportDefaultLoading';
import {DashboardID} from '/constant/TestIDs';
import {
  EXPIRING_REWARDS,
  EXPIRING_WELLNESS_CREDITS,
  NEXT_TASK,
  NO_ORDER,
  PREMIER_CANCELLATIONS,
  RECENTLY_INACTIVE,
} from '/enum/peopleToContact.enum';
import {EVENT_NAMES, SCREEN_NAMES} from '/enum/tealium.enum';
import {withSafeArea} from '/provider/SafeAreaProvider';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';
import {getTealiumUtilDefaultInstance} from '/util/tealium';
import testProperties from '/util/testing/testProperties';

import {styles} from './PeopleToContactDataProvider.style';
import {generateOnShowAllPress} from './PeopleToContactDataProvider.util';

class PeopleToContactDataProvider extends React.PureComponent {
  // This function is used to check the availability of
  // data for sorting.
  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  componentDidUpdate(prevProps: any) {
    const {hasReportData: hadReportData, reportParams: prevReportParams} =
      prevProps;
    // @ts-expect-error TS(2339): Property 'hasReportData' does not exist on type 'R... Remove this comment to see the full error message
    const {hasReportData, fetchReport, reportParams} = this.props;

    const sortChanged =
      JSON.stringify(prevReportParams) !== JSON.stringify(reportParams);

    if ((hadReportData && !hasReportData) || sortChanged) {
      setTimeout(fetchReport, 200);
    }
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  render() {
    let {
      // @ts-expect-error TS(2339): Property 'tt' does not exist on type 'Readonly<{}>... Remove this comment to see the full error message
      tt,
      // @ts-expect-error TS(2339): Property 'reportName' does not exist on type 'Read... Remove this comment to see the full error message
      reportName,
      // @ts-expect-error TS(2339): Property 'data' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      data,
      // @ts-expect-error TS(2339): Property 'onViewMore' does not exist on type 'Read... Remove this comment to see the full error message
      onViewMore,
      // @ts-expect-error TS(2339): Property 'personIsCoach' does not exist on type 'R... Remove this comment to see the full error message
      personIsCoach,
      // @ts-expect-error TS(2339): Property 'alternateItemKey' does not exist on type... Remove this comment to see the full error message
      alternateItemKey,
      // @ts-expect-error TS(2339): Property 'dataRendererProps' does not exist on typ... Remove this comment to see the full error message
      dataRendererProps: {
        personNameComponent: PersonNameComponent,
        personRoleComponent: PersonRoleComponent,
        personInfoComponent: PersonInfoComponent,
        CandidateDispositionInfo: CandidateDispositionInfo,
        NewLabelComponent: NewLabelComponent,
        AcceptByComponent: AcceptByComponent,
        AcceptByIconComponent: AcceptByIconComponent,
        onRecordPress,
        showFullReport,
      },
      // @ts-expect-error TS(2339): Property 'safeAreaInsets' does not exist on type '... Remove this comment to see the full error message
      safeAreaInsets,
      // @ts-expect-error TS(2339): Property 'reportIsLoading' does not exist on type ... Remove this comment to see the full error message
      reportIsLoading,
      // @ts-expect-error TS(2339): Property 'parentScreenName' does not exist on type... Remove this comment to see the full error message
      parentScreenName,
      // @ts-expect-error TS(2339): Property 'clientMilestone' does not exist on type ... Remove this comment to see the full error message
      clientMilestone,
      // @ts-expect-error TS(2339): Property 'fetchMoreReport' does not exist on type ... Remove this comment to see the full error message
      fetchMoreReport,
      // @ts-expect-error TS(2339): Property 'isClientJourneyLoading' does not exist o... Remove this comment to see the full error message
      isClientJourneyLoading,
      // @ts-expect-error TS(2339): Property 'isCandidateReport' does not exist on typ... Remove this comment to see the full error message
      isCandidateReport,
      // @ts-expect-error TS(2339): Property 'lastPaidRank' does not exist on typ... Remove this comment to see the full error message
      lastPaidRank,
    } = this.props;
    const renderListEmptyComponent = () => {
      if (reportIsLoading) {
        return <ReportDefaultLoading total={5} />;
      }

      return (
        <View style={styles.loading}>
          <Text allowFontScaling maxFontSizeMultiplier={2} variant="heading">
            {tt('noClients', 'No Clients')}
          </Text>
        </View>
      );
    };

    const sendEvent = getTealiumUtilDefaultInstance().generateTrackEvent({
      eventName: EVENT_NAMES.onPageLoad,
    });

    // @ts-expect-error TS(7030): Not all code paths return a value.
    const renderListFooterComponent = () => {
      if (!showFullReport && data?.length > 5) {
        return (
          <KeyboardFocusable
            focusable={true}
            accessible={true}
            accessibilityRole="button"
            accessibilityLabel="show all"
            style={styles.viewMoreOrderButton}
            onPress={generateOnShowAllPress({
              parentScreenName,
              currentScreenName: 'REPORT_CLIENTS_TO_CONTACT',
              onViewMore,
              sendEvent,
              lastPaidRank,
            })}
            {...testProperties(null, true)}>
            <Text
              allowFontScaling
              maxFontSizeMultiplier={2}
              accessible={false}
              useCompetency={true}
              variant="button"
              {...testProperties(DashboardID.clientsToContactShowAllButton)}>
              {tt('showAll', 'Show all')}
            </Text>
          </KeyboardFocusable>
        );
      }

      if (reportIsLoading) {
        return <ReportDefaultLoading total={3} />;
      }
    };
    // using shouldRenderData to check if there is an update in clientJourney tasks
    const shouldRenderData =
      clientMilestone === 'next_task' ? !isClientJourneyLoading : true;

    const UIListDisplay = (DataList: any) => {
      return showFullReport ? DataList : DataList?.slice(0, 5);
    };

    return (
      <ScrollView
        horizontal={true}
        contentContainerStyle={styles.scrollViewContainer}
        scrollEnabled={false}
        accessible={false}
        importantForAccessibility="no">
        {shouldRenderData ? (
          <FlatList
            bounces={false}
            contentContainerStyle={[
              styles.base,
              showFullReport && {
                ...styles.fullBase,
                paddingBottom: safeAreaInsets.bottom,
              },
            ]}
            onEndReachedThreshold={0.5}
            onEndReached={showFullReport ? fetchMoreReport : null}
            scrollEnabled={showFullReport}
            data={UIListDisplay(data)}
            keyExtractor={getKeyExtractor({alternateItemKey})}
            renderItem={getRenderItem({
              alternateItemKey,
              personIsCoach,
              PersonNameComponent,
              PersonRoleComponent,
              PersonInfoComponent,
              CandidateDispositionInfo,
              NewLabelComponent,
              AcceptByComponent,
              AcceptByIconComponent,
              reportName,
              isCandidateReport,
              clientMilestone,
              screenName: showFullReport
                ? SCREEN_NAMES.clientsToContact
                : parentScreenName,
              isPeopleToContactSection: true,
              onRecordPress,
              hasHorizontalPadding: showFullReport,
              lastPaidRank: lastPaidRank,
              totalCount: Number(UIListDisplay(data)?.length) || 0,
            })}
            ListEmptyComponent={renderListEmptyComponent()}
            ListFooterComponent={renderListFooterComponent()}
          />
        ) : (
          <ReportDefaultLoading total={data?.length > 5 ? 5 : data.length} />
        )}
      </ScrollView>
    );
  }
}

PeopleToContactDataProvider.propTypes = {
  data: PropTypes.array,
  onViewMore: PropTypes.func,
  personIsCoach: PropTypes.func,
  screenParams: PropTypes.shape({
    type: PropTypes.oneOf([
      NO_ORDER,
      PREMIER_CANCELLATIONS,
      EXPIRING_WELLNESS_CREDITS,
      EXPIRING_REWARDS,
      RECENTLY_INACTIVE,
      NEXT_TASK,
    ]),
  }),
  safeAreaInsets: withSafeArea.safeAreaInsetsPropType,
  dataRendererProps: PropTypes.shape({
    personNameComponent: PropTypes.func,
    personRoleComponent: PropTypes.func,
    personInfoComponent: PropTypes.func,
    candidateDispositionInfo: PropTypes.func,
    NewLabelComponent: PropTypes.func,
    AcceptByComponent: PropTypes.func,
    CandidateDispositionInfo: PropTypes.func,
    AcceptByIconComponent: PropTypes.func,
    onRecordPress: PropTypes.func,
    showFullReport: PropTypes.bool,
  }),
  reportName: PropTypes.string,
  reportParams: PropTypes.array,
  parentScreenName: PropTypes.string,
  alternateItemKey: PropTypes.string,
  isPeopleToContactSection: PropTypes.bool,
  tt: PropTypes.func,
  hasReportData: PropTypes.bool,
  fetchReport: PropTypes.func,
  reportIsLoading: PropTypes.bool,
  clientMilestone: PropTypes.string,
  fetchMoreReport: PropTypes.func,
  isClientJourneyLoading: PropTypes.bool,
  isCandidateReport: PropTypes.bool,
  lastPaidRank: PropTypes.string,
};

PeopleToContactDataProvider.defaultProps = {
  data: [],
  onViewMore: noop,
  personIsCoach: noop,
  screenParams: '',
  dataRendererProps: {},
  alternateItemKey: 'id',
  isPeopleToContactSection: false,
  tt: withTranslation.ttDefaultProp,
  safeAreaInsets: withSafeArea.safeAreaInsetsDefaultProp,
  hasReportData: false,
  fetchReport: noop,
  reportIsLoading: false,
  reportName: '',
  reportParams: [],
  clientMilestone: '',
  parentScreenName: '',
  fetchMoreReport: noop,
  isClientJourneyLoading: false,
  isCandidateReport: false,
  CandidateDispositionInfo: '',
  lastPaidRank: '',
};

export default withHOC(
  withTranslation('component.partial.peopleToContact.peopleToContactProvider'),
  withSafeArea,
)(memo(PeopleToContactDataProvider));
